import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import type { TemplateWithPlainImagesFrame } from 'hb-builder/components/RenderComponents/page/block/Strips/types/items';
import { ChildrenRenderer } from 'hb-builder/components/Renderer/ChildrenRenderer';
import ImageAsBackground from 'hb-builder/components/UIComponents/page/block/Strips/TemplateWithPlainImagesStripsItem/ImageAsBackground';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';

const TemplateWithPlainImagesStripsItem: RenderComponent = () => <div />; // never used

const Render = ({ item }: RenderProps<TemplateWithPlainImagesFrame>) => {
  const { subdomainNetworkUrl } = useRendererContext();
  const [image, wrapper, button] = item?.children || [];
  const [headline, subline] = wrapper?.children || [];

  const { clickable } = image?.attributes || {};

  const { buttonLink: link, buttonLinkNewPage: linkNewPage } =
    button?.attributes || {};

  const canClickOnHeadline = !!link && clickable;

  const props = {
    clickable,
    fallBackAltValue: headline?.content,
    hasLink: canClickOnHeadline,
    image,
    link,
    linkNewPage,
    subdomainNetworkUrl,
  };

  return (
    <ImageAsBackground {...props}>
      <WrapperUI dataTestId="template-plain-images-strips-wrapper">
        <StyledBox>
          <Box>
            {headline && <ChildrenRenderer item={{ children: [headline] }} />}
          </Box>
          {subline && <ChildrenRenderer item={{ children: [subline] }} />}
        </StyledBox>
        {button && <ChildrenRenderer item={{ children: [button] }} />}
      </WrapperUI>
    </ImageAsBackground>
  );
};

TemplateWithPlainImagesStripsItem.componentName =
  'TemplateWithPlainImagesStripsItem';
TemplateWithPlainImagesStripsItem.Render = Render;

export default TemplateWithPlainImagesStripsItem;

export const WrapperUI = styled(Box).attrs(() => ({
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between',
  width: '100%',
}))``;

const StyledBox = styled(Box).attrs(() => ({
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-start',
  width: '100%',
}))``;
